function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#C21313",
  d: "M12.5 3C9 3 5.9 4.9 4.3 7.8L2 5.5V12h6.5L5.7 9.2C7 6.7 9.5 5 12.5 5c4.1 0 7.5 3.4 7.5 7.5S16.6 20 12.5 20c-3.3 0-6-2.1-7.1-5H3.3c1.1 4 4.8 7 9.2 7 5.3 0 9.5-4.3 9.5-9.5S17.7 3 12.5 3zm-1.167 5.897v4.586l3 2.62 1-1.31-2-1.965V8.897h-2z"
});

function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgHistory;